<app-filter-input
    [property]="filter"
    (filterRef)="saveFilterRef($event)"
></app-filter-input>
